import React, { FC, MouseEvent, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { fc } from 'i18n';
import { Option } from './option';
import { column } from 'assets/icons';
import { localStorage } from 'core/app/storage';
import { ALL_TEP_COLUMNS_IDS } from 'constants/tep';
import Button from 'core/react/general/form/Button';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { tepTableSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

const getHiddenColumns = () => localStorage.get('tem-management-columns') || [];

export const ColumnsVisibility: FC = () => {
  const table = useSelector(tepTableSelector);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [hiddenIds, setHiddenIds] = useState<string[]>([]);

  const listClassname = classNames(styles.list, { [styles.show]: isOpen, [styles.hide]: !isOpen });

  const options = table?.allColumns?.filter((column) => ALL_TEP_COLUMNS_IDS.includes(column.id));

  const selectColumn = (id: string) => (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    const isSelected = !hiddenIds.includes(id);

    isSelected
      ? setHiddenIds([...hiddenIds, id])
      : setHiddenIds(hiddenIds.filter((selectedId: string) => selectedId !== id));
  };

  const apply = () => {
    localStorage.set('tem-management-columns', hiddenIds);

    (options || []).forEach((column) => column.toggleHidden(hiddenIds.includes(column.id)));

    setIsOpen(false);
  };

  useEffect(() => {
    setHiddenIds(getHiddenColumns());
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.button} onClick={() => setIsOpen(true)}>
        <SvgWrapper width={12} height={12} details={column} />
        <div>{fc('manage columns')}</div>
      </div>
      <div className={listClassname}>
        <div className={styles.title}>{fc('columns displayed')}</div>
        <div className={styles.options}>
          {options?.map((option, index) => (
            <Option
              key={index}
              isSelected={!hiddenIds.includes(option.id)}
              id={option.id}
              name={String(option.Header)}
              onSelect={selectColumn}
            />
          ))}
        </div>
        <div className={styles.listButtons}>
          <Button className={styles.listButton} onClick={() => setIsOpen(false)}>
            {fc('cancel')}
          </Button>
          <Button className={`${styles.listButton} active`} onClick={apply}>
            {fc('apply')}
          </Button>
        </div>
      </div>
    </div>
  );
};
